import { usePathname } from 'next/navigation'

import { LinkRoute } from '@/components/common/Link'
import { Icon } from '@/components/icons/Icon'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { useReduxSelector } from '@/store/hooks'
import { cn } from '@/utils/commonUtil'

import styles from './HeaderButtonUser.module.scss'

export const HeaderButtonUser = () => {
  const pathname = usePathname()
  const userStatus = useReduxSelector((s) => s.user.status)
  const displayName = useReduxSelector((s) => s.user.profile?.displayName)

  if (userStatus === 'signedIn') {
    return (
      <LinkRoute aria-label='Account Page' className={cn(styles.container, styles.account)} href='/account'>
        <span aria-hidden className={styles.icon}>
          <Icon name='circleUser' />
        </span>
        <span aria-hidden className={styles.iconWithLabel}>
          <IconWithLabel iconBefore='circleUser' iconBeforeSize='lg' wrapNone>
            {displayName || 'User'}
          </IconWithLabel>
        </span>
      </LinkRoute>
    )
  }

  if (userStatus === 'signedOut') {
    return (
      <LinkRoute
        aria-label='Sign In'
        className={cn(styles.container, styles.signIn)}
        href={`/signin?redirect=${encodeURIComponent(pathname)}`}
      >
        <span aria-hidden className={styles.icon}>
          <Icon name='user' />
        </span>
        <span aria-hidden className={styles.iconWithLabel}>
          <IconWithLabel iconBefore='user'>Sign In</IconWithLabel>
        </span>
      </LinkRoute>
    )
  }

  return (
    <div className={cn(styles.container, styles.loading)}>
      <span className={styles.iconSpinner}>
        <Icon name='spinner' />
      </span>
    </div>
  )
}
